import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  role: "User", // 'Admin' or 'User'
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.role = action.payload.role || "User";
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.role = "User";
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
